import { IEmailRepository } from "../interfaces/IEmailRepository"

export class InMemoryEmailRepository implements IEmailRepository {
  private emails: Array<{ email: string; date: Date }> = []

  async store(email: string): Promise<void> {
    this.emails.push({ email, date: new Date() })
  }
}
